<template>
	<div class="skip-icon">
		<img class="icon1" :data-src="g+imgList[0]" />
		<img class="icon2" :data-src="g+imgList[1]" />
	</div>
</template>

<script>
	export default{
		props:{
			type:{
				type:String,
				default:'1'
			}
		},
		name: "",
		components: {},
		data(){
			 let g=process.env.VUE_APP_BASE_URL+'sustainability'
			return{
				g:g,
				imgList:[],
			}
		},
		created(){
			if(this.type=='1'||!this.type){
				this.imgList=['/70.png','/71.png']
			}else{
				this.imgList=['/361.png','/362.png']
			}
		}
	}
</script>

<style lang="scss" scoped >
	.skip-icon{
		position: relative;
		width: 22px;
		height: 32px;
		display: inline-block;
		.icon1{
			    height: 30px;
			    left: 0px;
			    position: absolute;
			    top: 0px;
			    transform-origin: 0% 0%;
			    width: 20px;
		}
		.icon2{
			    height: 16px;
			    left: 4px;
			    position: absolute;
			    top: 5px;
			    transform-origin: 0% 0%;
			    width: 17px;
		}
	}
	
</style>